import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' }
});

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('imodeff_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchProperties = async (params = {}) => {
  const { data } = await api.get('/properties', { params });
  return data;
};

export const fetchProperty = async (slug) => {
  const { data } = await api.get(`/properties/${slug}`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post('/contact', payload);
  return data;
};

// Analytics tracking (fire-and-forget)
const getSessionId = () => {
  let id = localStorage.getItem('imodeff_session');
  if (!id) {
    id = (crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + Date.now());
    localStorage.setItem('imodeff_session', id);
  }
  return id;
};

export const trackPageview = (path, language) => {
  try {
    api.post('/analytics/pageview', {
      path,
      language: (language || 'EN').toUpperCase(),
      session_id: getSessionId(),
      referrer: document.referrer || '',
    }).catch(() => {});
  } catch (_) {}
};

export const trackPropertyView = (slug) => {
  try {
    api.post('/analytics/property-view', {
      slug,
      session_id: getSessionId(),
    }).catch(() => {});
  } catch (_) {}
};

// Admin
export const adminLogin = async (email, password) => {
  const { data } = await api.post('/admin/login', { email, password });
  return data;
};

export const fetchAdminMe = async () => (await api.get('/admin/me')).data;
export const fetchAdminAnalytics = async () => (await api.get('/admin/analytics')).data;
export const fetchAdminMessages = async () => (await api.get('/admin/messages')).data;
